import type { SendFn } from '@avisoma/agent-ui';
import backend from '../../services/backend';

export function createProjectAgentSend(projectId: string): SendFn {
  return ({ messages, signal }) => {
    const csrf = backend.getCsrfToken();
    return fetch(`/api/projects/${encodeURIComponent(projectId)}/agent/chat`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
        ...(csrf ? { 'X-CSRF-Token': csrf } : {}),
      },
      body: JSON.stringify({ messages }),
      signal,
    }).then((response) => {
      // fetch bypasses the axios interceptor, so an expired session is handed to the login redirect here.
      if (response.status === 401) backend.notifyUnauthorized();
      return response;
    });
  };
}
